/**
 * MARKETING → BLENDED SOM MENUGRUPPE ([D-556], Charlie 05-11-2026).
 *
 * Den lange Blended-side er delt i undersider, og Månedstal er flyttet ind som
 * den første. Listen her er den ENESTE kilde til undersiderne: routeren,
 * menuen, side-kataloget (grants) og API-adgangen læser den, så de ikke kan
 * drifte fra hinanden.
 *
 * `/marketing/blended` er nu kun gruppens prefix: den sender til den første
 * underside, brugeren må se. Månedstal har sit eget grant (siden viser
 * resultat før skat), de øvrige 5 er tegnet af det samme view (BlendedView)
 * med hver sin `tab`.
 */

export const BLENDED_BASE_PATH = '/marketing/blended';

/** Undersiderne, der tegnes af BlendedView (Månedstal har sit eget view). */
export type BlendedTab = 'traffic' | 'kpi' | 'trends' | 'geography' | 'attribution';

export interface BlendedPage {
  path: string;
  /** Menuens navn (3. niveau under Blended). */
  label: string;
  /** Sat for de undersider, BlendedView tegner. */
  tab?: BlendedTab;
}

/** I menuens rækkefølge (Charlies liste); den første er gruppens indgang. */
export const BLENDED_PAGES: readonly BlendedPage[] = [
  { path: `${BLENDED_BASE_PATH}/monthly`, label: 'Månedstal' },
  { path: `${BLENDED_BASE_PATH}/traffic`, label: 'Trafik', tab: 'traffic' },
  { path: `${BLENDED_BASE_PATH}/kpi`, label: 'KPI', tab: 'kpi' },
  { path: `${BLENDED_BASE_PATH}/trends`, label: 'Trends', tab: 'trends' },
  { path: `${BLENDED_BASE_PATH}/geography`, label: 'Geografi', tab: 'geography' },
  { path: `${BLENDED_BASE_PATH}/tracking-attribution`, label: 'Tracking & attribution', tab: 'attribution' },
];

/** Underside-stien for en tab. */
export function blendedTabPath(tab: BlendedTab): string {
  return BLENDED_PAGES.find((p) => p.tab === tab)!.path;
}
